import { ValidationErrors } from '../validation/validation-errors';
import { SectionDto } from './section-dto';

export class FormResponse<T> {
  public Entity: T;
  public Sections: { [key: string]: SectionDto };
  public ValidationErrors: ValidationErrors;
  public IsSubmitted: boolean;
  public hasSubmitValidationError?: boolean;
}
